import type { ReviewCheckType } from '@/api/client';

/** Подпись для пустого значения в интерфейсе (в т.ч. пункт списка «сбросить») */
export const REVIEW_NOT_SPECIFIED_LABEL = 'Не указано';

/** Плейсхолдер в ячейке / триггере дропдауна, пока тип не выбран */
export const REVIEW_CHECK_TYPE_PLACEHOLDER = 'Тип проверки';

/** Плейсхолдер для поля «без правок» */
export const NO_EDITS_PLACEHOLDER = 'Без правок';

/** Пустое значение в ячейке таблицы (в попапе редактирования — плейсхолдеры и «Не указано») */
export const REVIEW_TABLE_CELL_EMPTY = 'N/A';

export const REVIEW_CHECK_TYPES: readonly ReviewCheckType[] = [
  'normal',
  'full',
  'accelerated',
  'normal_urgent',
  'full_urgent',
  'accelerated_urgent',
];

export const REVIEW_CHECK_TYPE_LABELS: Record<ReviewCheckType, string> = {
  normal: 'Обычная',
  full: 'Полная',
  accelerated: 'Ускоренная',
  normal_urgent: 'Обычная срочная',
  full_urgent: 'Полная срочная',
  accelerated_urgent: 'Ускоренная срочная',
};

export function getReviewCheckTypeLabel(value: string | null | undefined): string | null {
  if (value == null || !String(value).trim()) return null;
  const key = value.trim() as ReviewCheckType;
  return REVIEW_CHECK_TYPE_LABELS[key] ?? null;
}

export function formatNoEdits(value: boolean | undefined): string {
  return value ? 'Да' : 'Нет';
}
